export const dictionary = {
  en: {
    attributes: {
      first_name: 'first name',
      last_name: 'last name',
      job_title: 'job title',
      address1: 'street address',
      organization_name: 'school/organization'
    }
  }
};
